export default __webpack_public_path__ + "static/media/delete-account-icon.e878e746.svg";